import { Redirect, useLocalSearchParams } from 'expo-router';

export default function LegacyTenantNewEventRedirect() {
  const { tenant } = useLocalSearchParams<{ tenant: string }>();
  return <Redirect href={{ pathname: '/admin/events/new', params: { tenant } }} />;
}
